module.exports = __webpack_public_path__ + "e619e187fbfc87c19c71ab2f3aa231e1.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/svg/header/logout.svg
// module id = ipAq
// module chunks = 11